module.exports = __webpack_public_path__ + "static/media/logo-white.5b675d48.png";